export const ITERABLE_API_URL = process.env.ITERABLE_API_URL;
export const ITERABLE_CLIENT_SIDE_API_KEY =
  process.env.ITERABLE_CLIENT_SIDE_API_KEY;

export const STORE_BASIC_AUTH_TOKEN = process.env.STORE_BASIC_AUTH_TOKEN;
